module.exports = "<div class=locations> <md-card flex> <rkc-toolbarheader toolbarheader-definition=c.toolbarheaderDefinition></rkc-toolbarheader> <rkc-searchform search-definition=c.searchDefinition></rkc-searchform> </md-card> <md-card ng-show=\"c.tableDefinition.promise || c.locations.length > 0\"> <rkc-table table-definition=c.tableDefinition table-content=c.locations></rkc-table> </md-card> <md-button class=\"md-fab md-fab-bottom-right\" ng-click=c.createLocation($event)> <md-icon>add</md-icon> </md-button> </div>";


/*****************
 ** WEBPACK FOOTER
 ** ./src/app/components/main/views/locations/locations.html
 ** module id = 513
 ** module chunks = 0
 **/